import { HexElementProperties } from '~/types/drill'
import { TOPIC_HEXAGON_PROPERTIES } from '~/shared/constants/drill.const'

export function getProperties(index: number): HexElementProperties {
  switch (index) {
    case 2:
    case 8:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
        color: '#ff5757',
        i18nKey: 'playAlt',
        splat: 'left',
        classNames: {
          button: 'bg-white',
          text: 'whitespace-nowrap font-bold text-lg text-black',
        },
      }

    case 5:
    case 11:
    case 13:
    case 15:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
      }

    case 16:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.SOLUTION,
      }

    default:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.DEFAULT,
      }
  }
}
